import * as ReactDOM from 'react-dom/client';
import { ToastProvider } from 'react-toast-notifications';
import App from './App';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <ToastProvider autoDismiss={true}>
    {' '}
    {/* ToastProvider ile App make it merge */}
    <App />
  </ToastProvider>
);
